import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import StyledDataGrid from "../../../../../../components/StyledDataGrid";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { getServerPoliciesRows } from "./checkRowsServerData";

const ServerPoliciesView = ({ entityData }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(getServerPoliciesRows(entityData));
  }, [entityData]);

  const columnsToShow = [
    {
      field: "source",
      headerName: "Source",
      renderCell: (params) => {
        return (
          <IntegrationImage
            name={params?.value}
            width={"24px"}
            newLogo={true}
            style={{ margin: "16px" }}
          />
        );
      },
    },
    {
      field: "policy",
      flex: 0.8,
      headerName: "Policy",
      renderCell: (params) => {
        return <TextIntegrationStyle title={""} value={params?.value} />;
      },
    },
    {
      field: "type",
      headerName: "Type",
      renderCell: (params) => {
        return <TextIntegrationStyle title={""} value={params?.value} />;
      },
    },
  ];

  return rows.length > 0 ? (
    <StyledDataGrid columns={columnsToShow} rows={rows} />
  ) : (
    <Typography variant="body2" fontWeight={"600"} mt={1}>
      No data available
    </Typography>
  );
};

export default ServerPoliciesView;
